import { createContext, useContext, useState , useEffect } from "react";
import http from "../api/http";
import { getStoredAuth } from "./auth-storage";
import { speakWelcome } from "../utils/speak";
const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getStoredAuth());
  useEffect(() => {
    if (user?.token) {
      http.defaults.headers.common.Authorization = `Bearer ${user.token}`;
    } else {
      delete http.defaults.headers.common.Authorization;
    }
    if (user?.codtiers) {
      http.defaults.headers.common["x-codtiers"] = user.codtiers;
    } else {
      delete http.defaults.headers.common["x-codtiers"];
    }
  }, [user]);

  const login = async ({ login, password }) => {

    // ton backend attend { nom, password }
    const res = await http.post("api/Login", { nom: login, password });
    if (!res.data?.success) throw new Error(res.data?.msg || "Échec de connexion");
    console.log("login response:", res.data);
    const displayName =
      res.data.Raisoc;
    const payload = {
      token: res.data.Token,            // renvoyé par ton backend
      codtiers: res.data.codtiers,
      canFacture: res.data.canFacture,
      displayName,
    };
    setUser(payload);
    localStorage.setItem("auth", JSON.stringify(payload));
    speakWelcome(); // message vocal de bienvenue (déclenché par le clic de connexion)
    return payload;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("auth");
    delete http.defaults.headers.common.Authorization;
    delete http.defaults.headers.common["x-codtiers"];
    // (option) http.post("/logout") côté serveur si tu en as un
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
